/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SubtitleInputs */



/**
* | output |
* | --- |
* | "Subtitle" |
*
* @param {SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle = /** @type {((inputs?: SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtitular")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legenda")
	return /** @type {LocalizedString} */ ("Subtitle")
});